<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle">W<span class="small2">HAT</span> S<span class="small2">TALIN</span> K<span class="small2">NEW</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitile2.vue?3210a833